export default __webpack_public_path__ + "static/media/logo-watermark-min.25023eea.png";